var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m24 37.954 8.661-9.074-1.446-1.38L25 34.01V10.046h-2V34.01l-6.215-6.51-1.446 1.38z",
    clipRule: "evenodd"
  })));
};
export { SvgArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDggNDgiCiAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNCAzNy45NTQxTDMyLjY2MTQgMjguODgwNEwzMS4yMTQ3IDI3LjQ5OTRMMjUuMDAwMiAzNC4wMDk4VjEwLjA0NTlIMjMuMDAwMlYzNC4wMTAyTDE2Ljc4NTQgMjcuNDk5NEwxNS4zMzg3IDI4Ljg4MDRMMjQgMzcuOTU0MVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";